import React, { Component } from 'react';
import Modal from 'react-modal';
import ChargeAmountModalUI from './ChargeAmountModalUI';
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils';

class ChargeAmountModalSF extends Component {
    constructor(props) {
        super(props);
        this.state = {
            successMsg: null,
            errorList: [],
            submitted: false,
            paidDate: '',
            paidDateError: null,
            amount1: '',
            amount1Error: null,
            amount2: '',
            amount2Error: null,
        };
    }

    render() {
        return (
            <ChargeAmountModalUI
                context={this.props.context}
                successMsg={this.state.successMsg}
                errorList={this.state.errorList}
                onSubmit={this.onSubmit}
                onCancelClick={this.onCancelClick}
                updateMode={this.props.updateMode}
                // Fields
                paidDate={this.state.paidDate}
                onPaidDateChange={(dateISO) => this.setState({ paidDate: dateISO })}
                paidDateError={this.state.paidDateError}
                setPaidDateError={(error) => this.setState({ paidDateError: error })}
                amount2={this.state.amount2}
                onAmount2Change={(event) => this.setState({ amount2: event.target.value })}
                amount2Error={this.state.amount2Error}
                setAmount2Error={(error) => this.setState({ amount2Error: error })}
            />
        );
    }

    componentDidMount() {
        Modal.setAppElement('body');
    }

    onSubmit = () => {
        if (this.state.submitted) return;

        this.setState({ submitted: true, successMsg: null, errorList: [] });

        const parseAmount = (amount) => {
            return parseFloat(amount.replace(/,/g, ''));
        }
        
        RestApiUtils.put(this.props.context,
            `/api/su/test/loans/${this.props.loan.loanId}/scheduledDate/${this.props.selectedRepayment.scheduledDateISO}/${this.props.selectedChargeType}/chargeAmount`,
            this.onSubmitCallback,
            {
                paidDateISO: this.state.paidDate,
                chargeAmountF: this.state.amount2,
            }

        );
    };

    onSubmitCallback = (response) => {
        const errorList = response.errorList.map(error => error.message);

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        });

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({ successMsg: null });
                this.onCancelClick();
                this.props.onRefreshClick('noBusy');
            }, 100);
        }
    };

    onCancelClick = () => {
        this.props.onCancelClick();
    };

}

export default ChargeAmountModalSF;
